import { Observable } from 'rxjs';
import { FormFrameworkEvent } from '../models';
import { FormStaticService } from '../services';

export interface ITriggerFunction {
    functionNames: string[] | undefined;
    timestamp: number;
    subFormName?: string;
    subFormIndex?: number;
}

export interface ITriggerExternalFormSave {
    id?: string;
    externallyTriggered?: boolean;
    silent?: boolean;
}

export abstract class IFormExternalActions {
    public abstract triggerSave(config?: ITriggerExternalFormSave): void;
    public abstract getTriggerSave$():
        | Observable<ITriggerExternalFormSave | undefined>
        | undefined;
    public abstract triggerSaveDraft(config?: ITriggerExternalFormSave): void;
    public abstract getTriggerSaveDraft$():
        | Observable<ITriggerExternalFormSave | undefined>
        | undefined;
    public abstract triggerFunction(
        functionName: string[],
        subFormName?: string,
        subFormIndex?: number,
    ): void;
    public abstract getTriggerFunction$():
        | Observable<ITriggerFunction>
        | undefined;
    public abstract patchFormValue(data: any): void;
    public abstract patchFormValue$(): Observable<any> | undefined;

    public abstract cleanup(): void;
    public abstract init(formStaticService: FormStaticService): void;
    public abstract closeSpawnedForms(event?: FormFrameworkEvent): void;
    public abstract handleQuickCreate(): void;
    public abstract handleOpenInNewTab(entity: string, id?: string): void;
}
